<div class="layout-column detail-table-container">
    @if (configTable.settings.headerAction) {
        <div class="detail-table-header responsive-layout">
            <!-- Left: search -->
            <div class="detail-table-header-left">
                @if (configTable.settings.search && !hasExternalFilter) {
                    <p-iconfield>
                        <p-inputicon class="pi pi-search"/>
                        <input
                                pInputText
                                [placeholder]="'search' | translate"
                                [ngModel]="ownSearchInput()"
                                (ngModelChange)="ownSearchInput.set($event); applyFilter(dt)"
                        />
                    </p-iconfield>
                }
            </div>

            <!-- Right: selection bar (when rows checked) or normal actions -->
            @if (configTable.selectionModel?.hasValue()) {
                <div class="detail-table-header-actions detail-table-selection-bar">
                    <span class="selection-count"
                    >{{ configTable.selectionModel!.selected().length }}
                        {{ 'table.selected' | translate }}</span
                    >
                    @for (button of configTable.buttons; track $index) {
                        @if (button.disableIfEmpty) {
                            <p-button
                                    severity="danger"
                                    [outlined]="true"
                                    [disabled]="button.disabled"
                                    (click)="button.onClick()"
                            >
                                @if (button.icon) {
                                    <i [class]="button.icon"></i>
                                }
                                {{ button.text | translate | uppercase }}
                            </p-button>
                        }
                    }
                </div>
            } @else {
                <div class="detail-table-header-actions">
                    @for (button of configTable.buttons; track $index) {
                        @if (!button.disableIfEmpty) {
                            @if (button.menuItems && button.menuItems.length > 0) {
                                <p-splitbutton
                                        [label]="button.text | translate | uppercase"
                                        [icon]="button.icon"
                                        [model]="getMenuItems(button, configTable.selectionModel)"
                                        (onClick)="button.onClick()"
                                        [disabled]="button.disabled"
                                />
                            } @else {
                                <p-button
                                        [class]="button.className"
                                        [disabled]="button.disabled"
                                        (click)="button.onClick()"
                                >
                                    @if (button.icon) {
                                        <i [class]="button.icon"></i>
                                    }
                                    {{ button.text | translate | uppercase }}
                                </p-button>
                            }
                        }
                    }
                </div>
            }
        </div>
    }

    <p-table
            #dt
            [value]="configTable.data"
            [paginator]="configTable.data.length > 0"
            [rows]="10"
            [rowsPerPageOptions]="[10, 25, 100]"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="'paginator.report' | translate"
            [sortMode]="'single'"
            [globalFilterFields]="getFilterFields()"
            [rowHover]="!!configTable.onRowClick"
            [scrollable]="true"
            class="detail-table"
    >
        @if (configTable.settings.header) {
            <ng-template #header>
                <tr>
                    @if (configTable.selectionModel) {
                        <th style="width: 3rem">
                            <p-checkbox
                                    [binary]="true"
                                    [ngModel]="configTable.selectionModel.hasValue() && isAllSelected()"
                                    [indeterminate]="configTable.selectionModel.hasValue() && !isAllSelected()"
                                    (ngModelChange)="toggleAllRows()"
                                    [ariaLabel]="checkboxLabel()"
                            >
                            </p-checkbox>
                        </th>
                    }
                    @for (column of configTable.displayedColumns; track column.PropertyName) {
                        <th
                                pSortableColumn="{{ column.PropertyName }}"
                                class="detail-table-header-cell"
                                style="min-width: 150px"
                        >
                            {{ pipeValue(column.HeaderPipes, column.HeaderCellName) | translate }}
                            <p-sortIcon [field]="column.PropertyName"/>
                        </th>
                    }
                </tr>
            </ng-template>
        }

        <ng-template #body let-element>
            <tr
                    (click)="handleClickEvent(element)"
                    [ngClass]="{
              'detail-table-row-click': configTable.onRowClick,
              'grey-out-row': configTable.shouldGreyOut ? configTable.shouldGreyOut(element) : false,
            }"
            >
                @if (configTable.selectionModel) {
                    <td (click)="$event.stopPropagation()">
                        <p-checkbox
                                [binary]="true"
                                [ngModel]="configTable.selectionModel.isSelected(element)"
                                (ngModelChange)="configTable.selectionModel.toggle(element)"
                                [ariaLabel]="checkboxLabel(element)"
                        >
                        </p-checkbox>
                    </td>
                }
                @for (column of configTable.displayedColumns; track column.PropertyName) {
                    <td class="detail-table-body-cell" style="min-width: 150px">
                        @if (column.Component) {
                            <ng-container
                                    *ngComponentOutlet="column.Component; inputs: element[column.PropertyName]"
                            />
                        } @else {
                            {{ pipeValue(column.BodyPipes, element[column.PropertyName]) | translate }}
                        }
                    </td>
                }
            </tr>
        </ng-template>

        <ng-template #empty>
            <tr>
                <td
                        [attr.colspan]="configTable.displayedColumns.length + (configTable.selectionModel ? 1 : 0)"
                        class="table-empty-cell"
                >
                    <i class="pi pi-inbox empty-state-icon"></i>
                    <p class="empty-state-message">
                        {{ configTable.emptyStateMessage || 'table.empty.noData' | translate }}
                    </p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
